import { TextField } from "@mui/material";

export const checkEmail = (email: string, error?: boolean): boolean => {
  if (error && email.includes("wbsedu")) return false;
  const emailRegex = /\S+@\S+\.\S+/;
  return emailRegex.test(email);
};

interface EmailInputProps {
  email: string;
  setEmail?: (email: string) => void;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  showValidation?: boolean;
  onBlur?: () => void;
}

const EmailInput = ({
  email,
  setEmail,
  disabled,
  required,
  error,
  showValidation = true,
  onBlur,
}: EmailInputProps): React.JSX.Element => {
  const isInvalid = !checkEmail(email, error);
  const showError = showValidation && isInvalid;

  return (
    <TextField
      sx={{
        "& .MuiInputBase-root": {
          color: showError
            ? (theme) => theme.palette.error.main
            : isInvalid
              ? undefined
              : (theme) => theme.palette.success.main,
        },
      }}
      disabled={disabled}
      focused={checkEmail(email)}
      color="success"
      required={required}
      fullWidth
      type="email"
      id="EmailInput"
      label="Email Adresse"
      variant="outlined"
      onChange={(e) => {
        if (setEmail) {
          setEmail(e.target.value);
        }
      }}
      value={email}
      onBlur={onBlur}
      error={showError}
      helperText={
        !showError
          ? ""
          : error && email.includes("wbsedu")
            ? "Email Adresse darf nicht 'wbsedu' enthalten"
            : "Bitte gib eine gültige Email Adresse ein"
      }
    />
  );
};

export default EmailInput;
